import React from 'react';
import SkeletonLib from 'react-loading-skeleton';

export default function Skeleton(props) {
    return <SkeletonLib baseColor={props.baseColor || '#d9d9d9'} {...props} />;
}
